import { render, staticRenderFns } from "./LandAccountRequested.vue?vue&type=template&id=ec92edce&"
import script from "./LandAccountRequested.vue?vue&type=script&lang=js&"
export * from "./LandAccountRequested.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports